module.exports = __webpack_public_path__ + "static/media/one_of_us.247b4de2.jpg";